import styled from 'styled-components';
import { media } from '../../utils';
import { Swiper } from 'swiper/react';

//Interface for the thumbnail path
interface VideoTileProps {
  videoThumbUrl?: string;
}

interface AudioTileProps {
  audioThumbUrl?: string;
}

//Customizing the Swiper Library
export const MySwiper = styled(Swiper)`
  padding: 0% 3% 0% 3%; //Add 3% padding to the sides

  .swiper-slide {
    margin-right: 0.5%; // 0.5% gap between each slide
    width: auto; //fix the width (*** MUST = width of SliderItem) OR 420px
    flex-shrink: 0;
  }

  .swiper-slide:last-child {
    margin-right: 0; //Remove margin on the last slide for a cleaner edge
  }

  //Nav Button Styling
  .swiper-button-prev,
  .swiper-button-next {
    color: ${({ theme }) => theme.bgColor};
    top: 30%; //move buttons up
    border: none;
    width: 25px;
    height: 150px;
    background-color:rgba(51, 255, 153, 0.9); //opacity 0.6 --> 0.9 hover
    border-radius: 10px;
  }

  /*
  //Hover for the Nav Buttons
  .swiper-button-prev:hover,
  .swiper-button-next:hover {
    background-color: rgba(51, 255, 153, 0.9);
  }*/

  //Nav Arrow Styling
  .swiper-button-prev::after,
  .swiper-button-next::after {
    font-size: 18px; //arrow icon size
    font-weight: bold;
    line-height: 1; /* ensure it doesn't push the container too large */
}
`;

// A wrapper for the entire slider section
export const SliderWrapper = styled.div`
  position: relative;
  margin-bottom: 4%;

  ${media('mobile')} {
    margin-bottom: 30px;
  }
`;

// The category title (e.g., "APEC 2025", "CEO 브리핑", etc.)
export const SliderTitle = styled.h2`
  display: block;
  font-size: 2em;
  font-weight: bold;
  margin-left: 4%;
  margin-bottom: 0.5%;

  ${media('tablet')} {
    font-size: 25px;
  }

  ${media('mobile')} {
    font-size: 20px;
    margin-left: 35px;
  }
`;

// The container for the horizontal list of items
// "overflow-x: auto" allows scrolling when items exceed the width\
// USING SWIPER INSTEAD
/*
export const SliderList = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-wrap: nowrap;
  overflow-x: auto;
  overflow-y: hidden;
  padding-left: 3%;
  gap: 0.5%;
`;*/

// Each "item" in the slider
// flex: 0 0 auto -> items won't shrink and won't expand; keep their width
// "Container" holding the VideoTile and title
export const VideoSliderItem = styled.div`
  width: 420px;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 0 0 auto;
  padding: 8px 10px 8px 10px; //padding betweeen SliderItem and VideoTile
  border: none;
  border-radius: 10px;
  overflow: hidden;
  cursor: pointer;

  &:hover {
    background-color: rgba(255, 255, 255, 0.5);
  }
`;

// Inner tile or thumbnail area
// You can place an <img> or background image here
export const VideoTile = styled.div<VideoTileProps>`
  width: 100%;
  background-color: ${({ theme }) => theme.thirdColor}; //fallback background
  aspect-ratio: 16 / 9;
  border-radius: 10px;
  
  background-image: url("${(props) => props.videoThumbUrl}");
  background-size: cover;
  background-position: center;

  /* Hover effect to mimic Netflix's slight zoom */
  transition: transform 0.2s;
  &:hover {
    transform: scale(1.03);
    z-index: 2; /* bring hovered item in front */
  }
`;

export const AudioSliderItem = styled.div`
  width: 240px;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 0 0 auto;
  padding: 8px 10px 8px 10px; //padding betweeen SliderItem and VideoTile
  border: none;
  border-radius: 10px;
  overflow: hidden;
  cursor: pointer;

  &:hover {
    background-color: rgba(255, 255, 255, 0.5);
  }
`;

export const AudioTile = styled.div<AudioTileProps>`
  width: 100%;
  background-color: ${({ theme }) => theme.thirdColor}; //fallback background
  aspect-ratio: 1 / 1;
  border-radius: 10px;
  
  background-image: url("${(props) => props.audioThumbUrl}");
  background-size: cover;
  background-position: center;

  /* Hover effect to mimic Netflix's slight zoom */
  transition: transform 0.2s;
  &:hover {
    transform: scale(1.03);
    z-index: 2; /* bring hovered item in front */
  }
`;

export const MediaTitle = styled.div`
  font-size: 1.1em;
  margin-top: 15px;
  color: #fff; 
  width: 100%;            /* matches the width of SliderItem's content */
  white-space: normal;    /* default, but explicit */
  word-wrap: break-word;  /* ensures long text won't overflow */
`;

export const NoMediaMessage = styled.div`
  font-size: 1.25em;
  margin: 15px 0px 0px 5%;
  color: #fff; 
  width: 100%;            /* matches the width of SliderItem's content */
  white-space: normal;    /* default, but explicit */
  word-wrap: break-word;  /* ensures long text won't overflow */
`;

